<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

  <v-container fluid fill-height align-start>

    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Formulario se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Formulario se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Formulario se edito con éxito.
       </v-alert>
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Formularios</h1>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card color="#393E46">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-text-field ref="nombreacto" :counter="50" type="text" label="Nombre" ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">

                  </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">

                    </v-col>

                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogdelete" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Desea eliminar esta Formulario?</v-card-title>
            <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">No</v-btn>
              <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

<div >

    <v-btn color="primary" dark class="mb-2" @click="dialog=true">Nuevo Formulario</v-btn>

        <v-data-table
      :headers="headers"
      :items="formularios"
      sort-by="Fecha"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Formularios</v-toolbar-title>
          <v-progress-circular
        indeterminate
        v-if="progr === true"
        color="primary"
      ></v-progress-circular>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>

        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          color="primary"
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-eye
        </v-icon>
          </template>
          <span>Actualiza Formulario</span>
        </v-tooltip>
      </template>


      <template v-slot:no-data>
        <v-btn color="primary" @click="dameformularios">Cargar de Nuevo</v-btn>
      </template>

    </v-data-table>
</div>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<style>
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import moment from "moment-timezone";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";
import Leftmenu from "@/components/general/leftmenu";
import md5 from "js-md5";

export default {
  title: 'Formularios | Tunay Mi acceso de bolsillo',

  components: {
    Leftmenu,
    Cabecerabaja

  },
    data: () => ({
      drawer: null,
      idnegocio: '',
      negocio: {},
      lahora:'20',
      elmin:'00',
      imagen : null,
      token:'',
      time: null,
      menu3: false,
      modal3: false,
      horas:[],
      minutos:[],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
      overlay: false,
      editedItem:{},
      date: new Date().toISOString().substr(0, 10),
              menu1: false,
      dialoguploadimage: false,
      dialoguploadlogo:false,
      vistatabla: false,
      formularios: [],
      abreviado:'',
      temporada:{},
      search: '',
      editedIndex: -1,

headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Formulario', align: 'left',  value: 'tipoFormulario'},
        { text: 'Fecha', value: 'fecha' },

      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
         this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)

        this.overlay = true
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.overlay = false
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.dameformularios();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

        }else{
      this.overlay = false
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.dameformularios();

    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     "$store.state.usuario": function (){
       if (this.usuario.id === undefined){
         this.$router.push({ path: '/' });
       }else{
       this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
       this.dameformularios();
       }
     },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
                     this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
                                 if (this.usuario.id === undefined){
                                   this.$router.push({ path: '/' });
           }else{

                                   this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

                                   this.dameformularios();
                 }
    },

  },
  methods : {
    formatFechasd(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("DD MMMM YYYY")
    },
    reload( response){
      console.log(response);
      this.dameformularios()
    },
    formatTime (date) {
      let hora = new Date('2020-10-10 '+date)
      return moment(hora).locale('es-pe').format("HH:mm");
    },
    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },
      formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    formatDarete (date) {
      var fec = moment(date).locale('es-pe');
      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("DD-MM-YYYY");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    dameformularios(){
      this.progr = true;
      this.overlay = true
            let urlfiesta = 'negociodisenio/negocio/' + this.negocio.id ;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.formularios = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false

        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        this.overlay = false
        });
    },
    editItem (item) {
      let idmd = md5(item.id.toString())
      console.log(idmd)
     this.$router.push({name:'DisenioMembresia', params:{ idnegocio: this.idnegocio, idhash: idmd}});
    },

    deleteItem (item) {
      this.editedIndex = this.formularios.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      this.overlay = true
      this.dialogdelete = false;
      axios
      .delete('actos/formularios/'+ this.formularios[this.editedIndex].id,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
        console.assert(true,response);

        this.alertborrador = true;
        this.dameformularios();
        this.overlay = false
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
        this.overlay = false
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      this.overlay = true
      if (this.editedIndex > -1) {
        Object.assign(this.formularios[this.editedIndex], this.editedItem);
        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));
       axios
      .post('actos/formularios/grabar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {

                this.alerteditar = true;
                this.formularios = response.data;
                this.overlay = false
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
              this.overlay = false
                });
      } else {
        var bodyFormData = new FormData();
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('actos/formularios/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.formularios = response.data;
                this.alertnuevo = true;
                console.log(response);
          this.overlay = false
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.error(error);
              this.overlay = false
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Formulario' : 'Editar Formulario'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      dias: "dias"
    })
  }
};
</script>
